module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_27.eecffcbd.png";